import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

// Native dialogs provide keyboard focus containment, Escape and focus restoration.
export default function Modal({ children, onClose, label, className = '' }) {
    const ref = useRef(null);
    useEffect(() => {
        const dialog = ref.current;
        const previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
        return () => {
            dialog.close();
            document.body.style.overflow = previousOverflow;
        };
    }, []);
    return createPortal(
        <dialog ref={ref} className={`site-dialog ${className}`} aria-label={label}
            onCancel={onClose} onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
            <button type="button" onClick={onClose} className="dialog-close" aria-label="Zavřít">×</button>
            {children}
        </dialog>, document.body
    );
}
